import { useTranslate } from "@refinedev/core";
import { Modal } from "@libertify/ui";

export type EmailPasswordAccountModalProps = {
  open: boolean;
  provider?: string;
  onGoToLogin: () => void;
  onClose: () => void;
};

export const EmailPasswordAccountModal = ({
  open,
  provider,
  onGoToLogin,
  onClose,
}: EmailPasswordAccountModalProps) => {
  const t = useTranslate();

  return (
    <Modal
      open={open}
      size="small"
      title={t("pages.auth.errors.emailAccountExists.title")}
      confirmText={t("pages.auth.errors.emailAccountExists.cta")}
      onConfirm={onGoToLogin}
      onClose={onClose}
    >
      <p>
        {t("pages.auth.errors.emailAccountExists.description", {
          provider: provider ?? "SSO",
        })}
      </p>
    </Modal>
  );
};
